import firebase from 'firebase/app';
import 'firebase/messaging';
console.log("firebase ", firebase);
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./sw.js').then((success) => {
        console.log("sw register successfully")
        callFirebase()
    }, (error) => {
        console.log(" not register successfully",error)
    });
} else {
    console.log("not present")
}
firebase.initializeApp({
    apiKey: "AIzaSyDAaRa-gLsgzcxbfHxaqnF3VuuBg5Dy3gg",
    authDomain: "imcl-lco-portal.firebaseapp.com",
    databaseURL: "https://imcl-lco-portal.firebaseio.com",
    projectId: "imcl-lco-portal",
    storageBucket: "imcl-lco-portal.appspot.com",
    messagingSenderId: "855346994430",
    appId: "1:855346994430:web:5dcf825fa8a9c1a3bbd9af",
    measurementId: "G-ZXG0PE26ZX"
});
function callFirebase () {
    console.log('callFirebase')
    let tokengen = "";
    firebase.messaging().requestPermission().then(function () {
        return firebase.messaging().getToken();
    }).then(function (token) {
        console.log("token", token);
        localStorage.setItem("token", (token))
        tokengen = token
    }).catch(function (error) {
        console.log('[App | initAWSMA | Notification | requestPermission | error ]', error);
    })

    let messageNotification = "";
    let createdDate = "";
    let imagePath = "";
    navigator.serviceWorker.addEventListener("message", (message) => {
        navigator.serviceWorker.ready.then(function (registration) {
            console.log(message)

            console.log("message data ", message)
            messageNotification = message.data['firebase-messaging-msg-data'].notification.body
            createdDate = message.data['firebase-messaging-msg-data'].notification.createddate
            imagePath = message.data['firebase-messaging-msg-data'].notification.image_url

            const notificationTitle = message.data['firebase-messaging-msg-data'].notification.title
            const notificationOptions = {
                body: messageNotification
            };

            if (localStorage.getItem("fcm-data")) {
                let getLocalFcm = JSON.parse(localStorage.getItem("fcm-data"));
                console.log(getLocalFcm);
                getLocalFcm.push({ 'message': messageNotification, 'createddate': createdDate, "imagepath": imagePath });
                localStorage.setItem("fcm-data", JSON.stringify(getLocalFcm))
            }
            else {
                let localfcm = [{ 'message': messageNotification }];
                localStorage.setItem("fcm-data", JSON.stringify(localfcm))
            }

            registration.showNotification(notificationTitle, notificationOptions);
        });
    });
}


// WEBPACK FOOTER //
// ./src/foreGroundMessage.js